module.exports = __webpack_public_path__ + "static/img/chainsaw_256.b0a98d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chainsaw_256.png
// module id = FmGj
// module chunks = 0